export const urls = {
    ACCOUNT: '/account',
    CART: '/cart',
    DISPUTES: '/disputes',
    HOMEPAGE: '/',
    REFILL: '/refill',
    REFILLS: '/refills',
    STOCKS: '/stocks',
    TERMS_OF_SERVICE: '/terms-of-service',

    auth: {
        ACTIVATION: '/auth/activation',
        LOGIN: '/auth/login',
        REGISTER: '/auth/register',
        RESET_PASSWORD: '/auth/reset-password',
    },

    catalogue: {
        products: {
            DETAILS: '/catalogue/products/:id',
            LIST: '/catalogue/products',
        },
    },

    orders: {
        DETAILS: '/orders/:id',
        LIST: '/orders',
    },

    purchases: {
        DETAILS: '/purchases/:id',
    },
}
